<div #header mat-dialog-title>
    Attachments
  </div>
  
  <mat-dialog-content style="padding-top: 10px !important;">
    <div>
        <mat-table [dataSource]="attachmentMatTable" aria-label="Attachment Table" tabindex="-1">
            <ng-container matColumnDef="FileName">
              <mat-header-cell *matHeaderCellDef translate>File Name
              </mat-header-cell>
              <mat-cell *matCellDef="let AR" >
                <a style="cursor: pointer" (click)="saveAttachment(AR)">
                  {{AR.FileName}}
                </a>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Description">
              <mat-header-cell *matHeaderCellDef translate>Description
              </mat-header-cell>
              <mat-cell *matCellDef="let AR">{{AR.AttachmentDescription}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="DocumentType">
              <mat-header-cell *matHeaderCellDef translate>File Type</mat-header-cell>
              <mat-cell *matCellDef="let AR">
                {{AR.DocumentType}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="UploadedDate">
              <mat-header-cell *matHeaderCellDef translate>Uploaded Date
              </mat-header-cell>
              <mat-cell *matCellDef="let AR">
                {{AR.AttachmentAddedOn|date:'MM/dd/yy h:mm a'}}</mat-cell>
            </ng-container>
    
            <mat-header-row *matHeaderRowDef="attachmentColumnsToDisplay" tabindex="-1">
            </mat-header-row>
            <mat-row *matRowDef="let row; let i = index; columns: attachmentColumnsToDisplay" tabindex="0">
            </mat-row>
          </mat-table>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions #footer>
    <div class='flex-footer-right'>
      <tyl-button image="Cancel.png" label="Close" (click)="closeClick()"></tyl-button>
    </div>
  </mat-dialog-actions>